// Store credentials
export function storeCredentials(payload) {
  return { type: 'credentials:store', payload };
}

// Delete credentials
export function removeCredentials() {
  return { type: 'credentials:remove' };
}
